import {
  type DeepReadonly,
  inject,
  provide,
  type Reactive,
  type Ref,
  type TeleportProps,
} from 'vue';

export type Context = {
  dataTestid?: DeepReadonly<Ref<string | undefined>>;
  isOpen: DeepReadonly<Ref<boolean>>;
};

export const LISTBOX_CONTEXT_KEY = Symbol();

export const provideListboxContext = (context: Context) => provide(LISTBOX_CONTEXT_KEY, context);

export const injectListboxContext = () =>
  inject<Context | undefined>(LISTBOX_CONTEXT_KEY, undefined);

type PortalContext = {
  teleportProps: Reactive<TeleportProps>;
};

export const LISTBOX_PORTAL_KEY = Symbol();
export const provideListboxPortalContext = (portalContext: PortalContext) =>
  provide(LISTBOX_PORTAL_KEY, portalContext);
export const injectListboxPortalContext = () =>
  inject<PortalContext | undefined>(LISTBOX_PORTAL_KEY, undefined);
